import React from 'react';
import { TopBar } from '../../components/layout/TopBar';
import { Header } from '../../components/layout/Header';
import { Navigation } from '../../components/layout/Navigation';
import { MobileStickyBar } from '../../components/layout/MobileStickyBar';
import { Footer } from '../../components/layout/Footer';
import { useScreenInit } from '../../useScreenInit';
import { usePageTitle } from '../../hooks/usePageTitle';
import { MapPin, Phone, Mail, Clock, User, HelpCircle, AlertTriangle, FileText, Building, CheckCircle2, Globe } from 'lucide-react';
export function ContactUs() {
  usePageTitle('Contact Us | MidAtlantic Mailboxes');
  useScreenInit();
  return <div className="min-h-screen flex flex-col bg-brand-background" data-id="element-988" data-mp="2imq6qnicr5sb">
      <TopBar data-id="element-989" data-mp="2ikwwyzcg05g3" />
      <Header data-id="element-990" data-mp="2ikn9pjis8ce3" />
      <Navigation data-id="element-991" data-mp="3p3bx8itoz6wr" />

      <main className="flex-grow" data-id="element-992" data-mp="3p3v9biwnv12v">
        {/* Hero Section */}
        <section className="bg-white border-b border-brand-border py-16 lg:py-24" data-id="element-993" data-mp="3u26ehgc0gner">
          <div className="max-w-7xl mx-auto px-4 text-center" data-id="element-994" data-mp="3u49connbhmuk">
            <span className="inline-block py-1 px-3 rounded-full bg-brand-goldSoft text-brand-charcoal text-xs font-bold tracking-wide mb-4 uppercase border border-brand-gold/30" data-id="element-995" data-mp="1f1uvdxfovqo4">
              We're Here to Help
            </span>
            <h1 className="text-4xl lg:text-5xl xl:text-6xl font-serif font-bold text-brand-charcoal mb-6 leading-tight" data-id="element-996" data-mp="164khe4bhlnfi">
              Contact & FAQs
            </h1>
            <p className="text-lg lg:text-xl text-brand-muted max-w-3xl mx-auto leading-relaxed mb-8" data-id="element-997" data-mp="w53dnsfspjm6">
              Get in touch with our expert team for help choosing the right
              product, identifying a replacement part, or planning a commercial
              project.
            </p>
            <div className="flex justify-center" data-id="element-998" data-mp="ie6lu3tp16g6">
              <img src="https://drwzpk38qkpfb.cloudfront.net/www.midatlanticmailboxes.com/uploaded/images/Redesign/Live%20Rep.png" alt="Live Representative at Midatlantic Mailbox" className="h-16 object-contain" data-id="element-999" data-mp="ddsnjdhw9avc" />
            </div>
          </div>
        </section>

        {/* Contact Info & Hours */}
        <section className="py-16 bg-brand-goldWash border-b border-brand-border" data-id="element-1000" data-mp="3rhqme6h5ffl">
          <div className="max-w-7xl mx-auto px-4" data-id="element-1001" data-mp="3lx4fzm9kcrx7">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1002" data-mp="3pxejms9vv68w">
              {/* Main Office */}
              <div className="bg-white p-8 rounded-xl border border-brand-border shadow-sm" data-id="element-1003" data-mp="hhuy6ffges4e">
                <div className="flex items-center gap-3 mb-6" data-id="element-1004" data-mp="mgo9q2b6k91x">
                  <div className="w-12 h-12 rounded-full bg-brand-background text-brand-maroon flex items-center justify-center" data-id="element-1005" data-mp="mfwfovx8ejdr">
                    <Building size={24} data-id="element-1006" data-mp="cquzp5qos1zs" />
                  </div>
                  <h2 className="text-2xl font-serif font-bold text-brand-charcoal" data-id="element-1007" data-mp="cp1tfrjzjjsb">
                    Main Office
                  </h2>
                </div>

                <div className="space-y-4 text-brand-muted" data-id="element-1008" data-mp="157fgcw3s9lcm">
                  <div className="flex items-start gap-3" data-id="element-1009" data-mp="1590fkz11lsgt">
                    <MapPin size={20} className="text-brand-maroon shrink-0 mt-1" data-id="element-1010" data-mp="2pw9qlb2nskgy" />
                    <p data-id="element-1011" data-mp="2zne5kasc45bs">
                      MidAtlantic Mailbox, Inc
                      <br data-id="element-1012" data-mp="2zpgvyvxeg0h1" />
                      4507 Metropolitan Court Ste D<br data-id="element-1013" data-mp="2uo1d9aip261t" />
                      Frederick, MD 21704
                    </p>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-1014" data-mp="26zi3srnwrn85">
                    <Phone size={20} className="text-brand-maroon shrink-0 mt-1" data-id="element-1015" data-mp="21zvpeewcg0xr" />
                    <p data-id="element-1016" data-mp="2gyhbo80uneu3">
                      <a href="tel:301-620-7585" className="hover:text-brand-maroon transition-colors" data-id="element-1017" data-mp="2gujqlgupod7k">
                        301-620-7585
                      </a>{' '}
                      or{' '}
                      <a href="tel:301-620-7867" className="hover:text-brand-maroon transition-colors" data-id="element-1018" data-mp="3ncglne7blq46">
                        301-620-7867
                      </a>
                    </p>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-1019" data-mp="25vi1h8hlo9t9">
                    <Clock size={20} className="text-brand-maroon shrink-0 mt-1" data-id="element-1020" data-mp="2ave2qzywxn54" />
                    <p data-id="element-1021" data-mp="2ftxn4vxuyqvd">
                      Monday - Friday: 10:30AM - 5:00PM (EST)
                      <br data-id="element-1022" data-mp="2kss926r4gvjp" />
                      Closed on Saturdays and Sundays
                    </p>
                  </div>
                  <div className="flex items-start gap-3 pt-2" data-id="element-1023" data-mp="2plbufpw1wuz2">
                    <Mail size={20} className="text-brand-maroon shrink-0 mt-1" data-id="element-1024" data-mp="2tl2hpjmdcsyu" />
                    <a href="mailto:customerservice@midatlanticmailboxes.com" className="text-brand-maroon hover:text-brand-maroonDark font-medium break-all" data-id="element-1025" data-mp="2yj43icb6j6e0">
                      customerservice@midatlanticmailboxes.com
                    </a>
                  </div>
                </div>
              </div>

              {/* Internet & Commercial Sales */}
              <div className="bg-white p-8 rounded-xl border border-brand-border shadow-sm" data-id="element-1026" data-mp="2zoqobjqz856d">
                <div className="flex items-center gap-3 mb-6" data-id="element-1027" data-mp="9c22trl7j4y">
                  <div className="w-12 h-12 rounded-full bg-brand-background text-brand-maroon flex items-center justify-center" data-id="element-1028" data-mp="8k79l5tdpfq">
                    <Globe size={24} data-id="element-1029" data-mp="3mowun3svk0xd" />
                  </div>
                  <h2 className="text-2xl font-serif font-bold text-brand-charcoal" data-id="element-1030" data-mp="3mndav380f7qu">
                    Internet & Commercial Sales
                  </h2>
                </div>

                <div className="space-y-4 text-brand-muted" data-id="element-1031" data-mp="j0v4aydset5x">
                  <div className="flex items-start gap-3" data-id="element-1032" data-mp="e9d5ogz8l4o4">
                    <Phone size={20} className="text-brand-maroon shrink-0 mt-1" data-id="element-1033" data-mp="e7to8n1ugnkr" />
                    <div className="space-y-1" data-id="element-1034" data-mp="2dgl7nvo8mxhr">
                      <p data-id="element-1035" data-mp="2dfa49wypfrr6">
                        <strong data-id="element-1036" data-mp="2dhwe6392ijck">Eastern region:</strong>{' '}
                        <a href="tel:240-575-5852" className="hover:text-brand-maroon transition-colors" data-id="element-1037" data-mp="1yqmcm1rzc26i">
                          240-575-5852
                        </a>
                      </p>
                      <p data-id="element-1038" data-mp="1upu08znt9h60">
                        <strong data-id="element-1039" data-mp="1ur54f0l64qxn">Western region:</strong>{' '}
                        <a href="tel:480-505-9240" className="hover:text-brand-maroon transition-colors" data-id="element-1040" data-mp="1fst6kqm27c4w">
                          480-505-9240
                        </a>
                      </p>
                      <p data-id="element-1041" data-mp="3f5f77fcieqvj">
                        <strong data-id="element-1042" data-mp="3f5nlnboa648u">Toll Free:</strong>{' '}
                        <a href="tel:800-469-1203" className="hover:text-brand-maroon transition-colors" data-id="element-1043" data-mp="3f3b3oyiivtvs">
                          800-469-1203
                        </a>
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-1044" data-mp="18hevjtjl8cec">
                    <Clock size={20} className="text-brand-maroon shrink-0 mt-1" data-id="element-1045" data-mp="18fu081pg8pff" />
                    <p data-id="element-1046" data-mp="1i7hm7n38le9i">
                      Monday - Friday: 9:00AM to 5:00PM (MST)
                      <br data-id="element-1047" data-mp="1w6prmxpztim5" />
                      <span className="text-sm italic" data-id="element-1048" data-mp="1w6zh8k74lnrb">
                        Please note we have an East Coast & West Coast office
                        that operate in different time zones.
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Our Team */}
        <section className="py-16 bg-white border-b border-brand-border" data-id="element-1049" data-mp="376diepoktifu">
          <div className="max-w-7xl mx-auto px-4" data-id="element-1050" data-mp="3c4x4cq366u87">
            <h2 className="text-3xl font-serif font-bold text-brand-charcoal mb-8 text-center" data-id="element-1051" data-mp="3c3m0kq9q5mh3">
              Our Team
            </h2>
            <p className="text-center text-brand-muted mb-10 max-w-2xl mx-auto" data-id="element-1052" data-mp="3gxzo66i5apb7">
              Please feel free to contact any one of our team members directly
              via email or phone at{' '}
              <a href="tel:301-620-7585" className="text-brand-maroon hover:underline" data-id="element-1053" data-mp="2o9c8qrk2uu5k">
                301-620-7585
              </a>
              .
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1054" data-mp="3348mfkano9q1">
              {[{
              name: 'Anne Ingram',
              title: 'Chief Executive Officer & Owner',
              email: 'anne@midatlanticmailbox.biz'
            }, {
              name: 'Lora Dragovich',
              title: 'Lead Commercial & E Commerce Sales Manager',
              email: 'lorad@midatlanticmailboxes.com'
            }, {
              name: 'Brooke Ingram',
              title: 'Operations Manager & Street Sign Specialist',
              email: 'brooke@midatlanticmailbox.biz'
            }, {
              name: 'Rachel Ingram-Conway',
              title: 'Business Development & Residential Specialist',
              email: 'rachel@midatlanticmailbox.biz'
            }].map((member, idx) => <div key={idx} className="bg-brand-background p-6 rounded-xl border border-brand-border text-center flex flex-col items-center" data-id="element-1055" data-mp="1a7mwid310ajl" data-mpi={idx}>
                  <div className="w-14 h-14 rounded-full bg-brand-goldWash text-brand-maroon flex items-center justify-center mb-4" data-id="element-1056" data-mp="34kmgsjicpsx7">
                    <User size={24} data-id="element-1057" data-mp="3v9excu6bhdnk" />
                  </div>
                  <h3 className="font-bold text-brand-charcoal text-lg mb-1" data-id="element-1058" data-mp="3v7u4ra3kc4sc">
                    {member.name}
                  </h3>
                  <p className="text-sm text-brand-muted mb-4 flex-grow" data-id="element-1059" data-mp="84pbwr5875a4">
                    {member.title}
                  </p>
                  <a href={`mailto:${member.email}`} className="text-sm text-brand-maroon hover:text-brand-maroonDark font-medium break-all" data-id="element-1060" data-mp="44f6bflcigvs">
                    {member.email}
                  </a>
                </div>)}
            </div>
          </div>
        </section>

        {/* Services & Communities */}
        <section className="py-16 bg-brand-background border-b border-brand-border" data-id="element-1061" data-mp="3gk90vdyv61jd">
          <div className="max-w-7xl mx-auto px-4" data-id="element-1062" data-mp="2suya8pb89niy">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-1063" data-mp="2stn5on9ykbqs">
              <div data-id="element-1064" data-mp="2oue97anj9zrj">
                <h2 className="text-2xl font-serif font-bold text-brand-charcoal mb-6" data-id="element-1065" data-mp="2ot38xktara56">
                  Your Mailbox Experts Are Here to Help!
                </h2>
                <ul className="space-y-4 text-brand-muted" data-id="element-1066" data-mp="2jgwhu4574n22">
                  <li className="flex items-start gap-3" data-id="element-1067" data-mp="2jih7bfcnlft2">
                    <CheckCircle2 size={20} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-1068" data-mp="24sjkp3udgy5z" />
                    <span className="text-lg" data-id="element-1069" data-mp="2xg5tqrmdcv08">
                      Replacement CBU's & New Developments
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1070" data-mp="32eqls3rgw8dl">
                    <CheckCircle2 size={20} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-1071" data-mp="2nihnb4fehz28" />
                    <span className="text-lg" data-id="element-1072" data-mp="2sf86i0mi5arv">
                      Advisal of Commercial Postal Codes & Ordinances
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1073" data-mp="1h2yuq0zsx0n7">
                    <CheckCircle2 size={20} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-1074" data-mp="3jol0e3a5k9uj" />
                    <span className="text-lg" data-id="element-1075" data-mp="3eq02iaidi299">
                      Value Engineered Development Mailbox Mapping
                    </span>
                  </li>
                </ul>
              </div>

              <div data-id="element-1076" data-mp="34z5ccv20aiij">
                <h2 className="text-2xl font-serif font-bold text-brand-charcoal mb-6" data-id="element-1077" data-mp="34xkgn23ygtj3">
                  Communities Serviced by Midatlantic Mailbox
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-3 gap-x-6 text-brand-muted" data-id="element-1078" data-mp="2vxfbkym8i783">
                  <a href="/3948.html" className="flex items-center gap-2 hover:text-brand-maroon transition-colors" data-id="element-1079" data-mp="2r0fgfiqxaovr">
                    <MapPin size={16} className="text-brand-gold" data-id="element-1080" data-mp="p7hij8iah63y" />
                    Regency at Dominion Valley: Haymarket, VA
                  </a>
                  <div className="flex items-center gap-2" data-id="element-1081" data-mp="k7msf76c8kjy">
                    <MapPin size={16} className="text-brand-gold" data-id="element-1082" data-mp="rs76d2g45v16" />
                    Lenah Mills: Aldie, VA
                  </div>
                  <div className="flex items-center gap-2" data-id="element-1083" data-mp="wpp4dxslepue">
                    <MapPin size={16} className="text-brand-gold" data-id="element-1084" data-mp="11k34uem43n5x" />
                    Skeeter Lake: Roundhill, VA
                  </div>
                  <div className="flex items-center gap-2" data-id="element-1085" data-mp="16jpi2o1xx3eq">
                    <MapPin size={16} className="text-brand-gold" data-id="element-1086" data-mp="8veacyfkag35" />
                    Brunswick Crossing: Frederick, MD
                  </div>
                  <div className="flex items-center gap-2" data-id="element-1087" data-mp="isaaogvb3vwm">
                    <MapPin size={16} className="text-brand-gold" data-id="element-1088" data-mp="iqpgiscwmeza" />
                    Villages at Urbana: Frederick, MD
                  </div>
                  <div className="flex items-center gap-2" data-id="element-1089" data-mp="1u7foafwz7ev0">
                    <MapPin size={16} className="text-brand-gold" data-id="element-1090" data-mp="1u75zuwrkxfrf" />
                    Greencastle Green: Greencastle, PA
                  </div>
                  <div className="flex items-center gap-2" data-id="element-1091" data-mp="1wrlsmopi57c3">
                    <MapPin size={16} className="text-brand-gold" data-id="element-1092" data-mp="1ws5ay6j2dxqn" />
                    Copper Run Drive: Monroe, LA
                  </div>
                  <div className="flex items-center gap-2" data-id="element-1093" data-mp="26qkthl40zyoj">
                    <MapPin size={16} className="text-brand-gold" data-id="element-1094" data-mp="26nylxlh4xj6b" />
                    Regency at Trotter's Point: Tinton Falls, NJ
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQs */}
        <section className="py-16 lg:py-24 bg-white border-b border-brand-border" data-id="element-1095" data-mp="2bocwpba4f781">
          <div className="max-w-4xl mx-auto px-4" data-id="element-1096" data-mp="2pgstvvgccb11">
            <h2 className="text-3xl font-serif font-bold text-brand-charcoal mb-10 text-center" data-id="element-1097" data-mp="2pinhjhizyh8t">
              Frequently Asked Questions
            </h2>

            <div className="space-y-6" data-id="element-1098" data-mp="2zfs1dapde0mg">
              {/* General / Install */}
              <div className="bg-brand-background p-6 rounded-xl border border-brand-border" data-id="element-1099" data-mp="2ug5o519jkkdn">
                <h3 className="font-bold text-brand-charcoal text-lg mb-2 flex items-center gap-2" data-id="element-1100" data-mp="3e0w73p54syw1">
                  <HelpCircle size={20} className="text-brand-maroon shrink-0" data-id="element-1101" data-mp="3i3j0huhgarvc" />
                  I didn’t buy my mailbox from Midatlantic Mailbox. Will you
                  still install it?
                </h3>
                <p className="text-brand-muted leading-relaxed pl-7" data-id="element-1102" data-mp="3945nwsy15n6e">
                  It depends! If you are in our service area and there is
                  availability on our schedule, we can complete a direct burial
                  installation. However we can only guarantee the craftsmanship
                  of the physical installation; any issues with the products
                  should be brought to the company you purchased from. Call{' '}
                  <a href="tel:301-620-7585" className="text-brand-maroon hover:underline" data-id="element-1103" data-mp="2bf43k4tnqy6y">
                    301-620-7585
                  </a>{' '}
                  to request an installation today!
                </p>
              </div>

              <div className="bg-brand-background p-6 rounded-xl border border-brand-border" data-id="element-1104" data-mp="1sgr5u8u1qqtj">
                <h3 className="font-bold text-brand-charcoal text-lg mb-2 flex items-center gap-2" data-id="element-1105" data-mp="1njqx1q5tb9yq">
                  <HelpCircle size={20} className="text-brand-maroon shrink-0" data-id="element-1106" data-mp="1ilper7g7neob" />
                  Do I need post office approval to replace my mailbox?
                </h3>
                <p className="text-brand-muted leading-relaxed pl-7" data-id="element-1107" data-mp="2b6z3ibez8p2c">
                  Unless you’re moving your mailbox location, you generally
                  don’t need USPS approval to complete a residential
                  installation. We’ll ensure your mailbox is compliant with USPS
                  regulations during installation. All of Midatlantic Mailbox’s
                  products are also USPS Approved.
                </p>
              </div>

              {/* 4C Mailboxes */}
              <div className="bg-brand-background p-6 rounded-xl border border-brand-border" data-id="element-1108" data-mp="31gzkb0nwu435">
                <h3 className="font-bold text-brand-charcoal text-lg mb-2 flex items-center gap-2" data-id="element-1109" data-mp="36fkh0q3ye5mu">
                  <HelpCircle size={20} className="text-brand-maroon shrink-0" data-id="element-1110" data-mp="3bf6v11rlvpwp" />
                  Are 4C mailboxes USPS approved?
                </h3>
                <p className="text-brand-muted leading-relaxed pl-7 mb-4" data-id="element-1111" data-mp="3p8en0ujlmnex">
                  Yes, 4C mailboxes are the newest USPS code-approved systems,
                  made per USPS regulations outlined in the Federal Registry. 4C
                  mailboxes meet or exceed STD-4C requirements for new
                  construction and major renovations.
                </p>
                <div className="pl-7 space-y-4" data-id="element-1112" data-mp="1zvl10n51tpsd">
                  <div data-id="element-1113" data-mp="24rrx7o7n7mx4">
                    <strong className="text-brand-charcoal block mb-1" data-id="element-1114" data-mp="24t38e93f3wy9">
                      How are they installed?
                    </strong>
                    <p className="text-brand-muted text-sm" data-id="element-1115" data-mp="5lw8zw5ppnkv">
                      Preferred installation is recessed into the wall, however
                      there is a surface-mounted or a depot option available.
                      Both may require USPS approval.
                    </p>
                  </div>
                  <div data-id="element-1116" data-mp="3nqg0udgz3zdl">
                    <strong className="text-brand-charcoal block mb-1" data-id="element-1117" data-mp="3ns0y4auo9wf5">
                      Are they ADA approved?
                    </strong>
                    <p className="text-brand-muted text-sm" data-id="element-1118" data-mp="1k1at0j2vqbb">
                      4C Mailboxes are produced to meet USPS code; ADA is a
                      separate entity. There are full USPS & ADA compliant units
                      available. Call 301-620-7585 to connect with a 4C
                      specialist.
                    </p>
                  </div>
                  <div data-id="element-1119" data-mp="17ztphgglqbqr">
                    <strong className="text-brand-charcoal block mb-1" data-id="element-1120" data-mp="1fjmak8o602le">
                      What is a Parcel locker and is it required?
                    </strong>
                    <p className="text-brand-muted text-sm" data-id="element-1121" data-mp="1kk0i7plutaiw">
                      A Parcel Locker is required for all USPS package
                      deliveries. To be compliant, it must be 15” tall. For
                      every 10 tenant slots, 5 parcel lockers are required by
                      USPS Code.
                    </p>
                  </div>
                  <div data-id="element-1122" data-mp="239go6sgb5v6p">
                    <strong className="text-brand-charcoal block mb-1" data-id="element-1123" data-mp="238p1k74ov7sk">
                      Lead times & Customization?
                    </strong>
                    <p className="text-brand-muted text-sm" data-id="element-1124" data-mp="1tj5hwz95j9wn">
                      Production varies from 4-6 weeks depending on quantity and
                      colors. There are limited custom options available.
                    </p>
                  </div>
                </div>
              </div>

              {/* 4B+ Mailboxes */}
              <div className="bg-brand-background p-6 rounded-xl border border-brand-border" data-id="element-1125" data-mp="hgpvr0o6tzw7">
                <h3 className="font-bold text-brand-charcoal text-lg mb-2 flex items-center gap-2" data-id="element-1126" data-mp="md6hjo7x0264">
                  <HelpCircle size={20} className="text-brand-maroon shrink-0" data-id="element-1127" data-mp="7otujgqt1tnr" />
                  Are Horizontal or Vertical (4B+) mailboxes USPS approved?
                </h3>
                <p className="text-brand-muted leading-relaxed pl-7 mb-4" data-id="element-1128" data-mp="3uwnsr5jfg63h">
                  No, 4B+ Horizontal and Vertical mailboxes are not USPS
                  approved for new construction, renovations, or updates. As of
                  July 2020 USPS Code Amendments, any renovation requires an
                  upgrade to CBU or 4C systems. They are only considered
                  approved if replacing existing mailboxes (at the discretion of
                  your local Postmaster). We ALWAYS advise confirming with your
                  local USPS Postmaster prior to purchasing.
                </p>
                <div className="pl-7 space-y-4" data-id="element-1129" data-mp="33n2pvm2ryluw">
                  <div data-id="element-1130" data-mp="33odvzsjp05p6">
                    <strong className="text-brand-charcoal block mb-1" data-id="element-1131" data-mp="33kyd0emwecih">
                      Customization & Installation?
                    </strong>
                    <p className="text-brand-muted text-sm" data-id="element-1132" data-mp="3djxmu0jege72">
                      Limited options for horizontal, no custom options for
                      vertical. Vertical can be surface or recessed-mounted.
                      Horizontal must be recessed.
                    </p>
                  </div>
                  <div data-id="element-1133" data-mp="53uio4rhx7nh">
                    <strong className="text-brand-charcoal block mb-1" data-id="element-1134" data-mp="532uhf08ac78">
                      Lead times?
                    </strong>
                    <p className="text-brand-muted text-sm" data-id="element-1135" data-mp="26waciw7877wt">
                      Horizontal units: 6-8 weeks. Vertical units: 7-14 business
                      days. Transit time depends on location.
                    </p>
                  </div>
                  <div data-id="element-1136" data-mp="5w5bwwryz8rg">
                    <strong className="text-brand-charcoal block mb-1" data-id="element-1137" data-mp="5wnhwl4fp1ck">
                      What is included?
                    </strong>
                    <p className="text-brand-muted text-sm" data-id="element-1138" data-mp="eupm19jgsa42">
                      Units include tenant locks with 2 keys each and number
                      slot card door ID per each door.
                    </p>
                  </div>
                </div>
              </div>

              {/* Street Signs */}
              <div className="bg-brand-background p-6 rounded-xl border border-brand-border" data-id="element-1139" data-mp="tqyk47rmchew">
                <h3 className="font-bold text-brand-charcoal text-lg mb-2 flex items-center gap-2" data-id="element-1140" data-mp="yk9kpr5u81yd">
                  <HelpCircle size={20} className="text-brand-maroon shrink-0" data-id="element-1141" data-mp="12ja0t1wxkqho" />
                  Street Sign FAQs
                </h3>
                <div className="pl-7 space-y-4" data-id="element-1142" data-mp="1cjso66npep4c">
                  <div data-id="element-1143" data-mp="1mmobffyfixcx">
                    <strong className="text-brand-charcoal block mb-1" data-id="element-1144" data-mp="1mn7ke763qbet">
                      I only need a replacement part - what do I do?
                    </strong>
                    <p className="text-brand-muted text-sm" data-id="element-1145" data-mp="1hpxvcsmmk1ri">
                      Call Midatlantic Mailbox! Our sign specialist can identify
                      the replacement part needed via photos to provide an
                      estimate.
                    </p>
                  </div>
                  <div data-id="element-1146" data-mp="25f09vrlypehs">
                    <strong className="text-brand-charcoal block mb-1" data-id="element-1147" data-mp="20dkpm1rlzc0g">
                      How are street signs shipped?
                    </strong>
                    <p className="text-brand-muted text-sm" data-id="element-1148" data-mp="1vljj6wh4gfic">
                      Full systems ship via Freight due to post length. Single
                      blades ship standard. We offer Telescoping Poles to save
                      on freight charges.
                    </p>
                  </div>
                  <div data-id="element-1149" data-mp="2jau9tl4rctir">
                    <strong className="text-brand-charcoal block mb-1" data-id="element-1150" data-mp="23uxfl8hoxp41">
                      What materials are they made of?
                    </strong>
                    <p className="text-brand-muted text-sm" data-id="element-1151" data-mp="28vlcubwij26p">
                      Most systems (blade, bracket, post, base) are derived from
                      durable aluminum.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Policies */}
        <section className="py-16 lg:py-24 bg-brand-charcoal text-white" data-id="element-1152" data-mp="2rk8hitas1pjr">
          <div className="max-w-5xl mx-auto px-4" data-id="element-1153" data-mp="2rmm7inqlobkg">
            <div className="text-center mb-12" data-id="element-1154" data-mp="2ds20z63ppgjs">
              <FileText size={40} className="text-brand-gold mx-auto mb-4" data-id="element-1155" data-mp="2dragorfkf58t" />
              <h2 className="text-3xl font-serif font-bold mb-4" data-id="element-1156" data-mp="2ht5dbimjwug9">
                Our Policies
              </h2>
              <p className="text-gray-300 max-w-2xl mx-auto" data-id="element-1157" data-mp="35i6h2skfvhf7">
                Please review our return, damage, and cancellation policies. For
                excellent customer service, contact us at{' '}
                <a href="tel:240-575-5852" className="text-brand-gold hover:underline" data-id="element-1158" data-mp="yto0llqshgeh">
                  240-575-5852
                </a>{' '}
                or{' '}
                <a href="tel:301-620-7585" className="text-brand-gold hover:underline" data-id="element-1159" data-mp="13n0oftnn9j66">
                  301-620-7585
                </a>
                .
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1160" data-mp="azd48fqacuk2">
              {/* Returns */}
              <div className="bg-white/5 border border-white/10 p-6 rounded-xl" data-id="element-1161" data-mp="pw40wh8krs5z">
                <h3 className="text-xl font-bold text-brand-gold mb-3 flex items-center gap-2" data-id="element-1162" data-mp="kv7tvusxfpwc">
                  <AlertTriangle size={20} data-id="element-1163" data-mp="219g5iuc5set7" />
                  Return Policy
                </h3>
                <ul className="space-y-3 text-sm text-gray-300" data-id="element-1164" data-mp="1wc7oix2qygtj">
                  <li data-id="element-1165" data-mp="23emiqw2n21ln">
                    • Email{' '}
                    <a href="mailto:customerservice@midatlanticmailboxes.com" className="text-white hover:underline" data-id="element-1166" data-mp="23e30fe92tb73">
                      customerservice@midatlanticmailboxes.com
                    </a>{' '}
                    to obtain a return authorization number (RGA#). RGA is
                    required for all returns.
                  </li>
                  <li data-id="element-1167" data-mp="1km0gnu151esm">
                    • Returns must be made within 30 days from receipt, in new
                    condition, and original packaging.
                  </li>
                  <li data-id="element-1168" data-mp="1ukq0vtgibbc1">
                    • Minimum restocking fee of 25% or $25 applies. Many
                    manufacturers may not allow returns if the item is not
                    defective.
                  </li>
                  <li data-id="element-1169" data-mp="11vizmmpo47n3">
                    • Shipping charges for the return are the customer's
                    responsibility. Original shipping charges are
                    non-refundable.
                  </li>
                  <li data-id="element-1170" data-mp="3g5nzjk4nuwk0">
                    • Products that have been installed or customized are not
                    returnable.
                  </li>
                  <li data-id="element-1171" data-mp="3b4qmflyicspd">
                    • Call{' '}
                    <a href="tel:800-806-7997" className="text-white hover:underline" data-id="element-1172" data-mp="367qet6m0fhw5">
                      800-806-7997
                    </a>{' '}
                    to determine your return requirements.
                  </li>
                </ul>
              </div>

              {/* Damages & Cancellations */}
              <div className="space-y-8" data-id="element-1173" data-mp="2ngpdibxf3a9f">
                <div className="bg-white/5 border border-white/10 p-6 rounded-xl" data-id="element-1174" data-mp="2ni0igf2lmo24">
                  <h3 className="text-xl font-bold text-brand-gold mb-3" data-id="element-1175" data-mp="2ihw4avp5y5f2">
                    Damage Inspections
                  </h3>
                  <p className="text-sm text-gray-300 mb-3" data-id="element-1176" data-mp="2djbabe0i8hz2">
                    <strong data-id="element-1177" data-mp="672wex2mjnll">
                      All items must be inspected for concealed damage or
                      shortage within 3 days of delivery to receive credit.
                    </strong>
                  </p>
                  <p className="text-sm text-gray-300" data-id="element-1178" data-mp="3se1beaol7lbe">
                    Report damages, defects, or shipping errors within 3
                    business days by calling{' '}
                    <a href="tel:800-806-7997" className="text-white hover:underline" data-id="element-1179" data-mp="3inonq9lh7c11">
                      1-800-806-7997
                    </a>
                    . Damaged products must be left in the original box with
                    packing materials. Do not discard any items; a shipping
                    representative may need to inspect them. Orders returned or
                    discarded without authorization will NOT be refunded.
                  </p>
                </div>

                <div className="bg-white/5 border border-white/10 p-6 rounded-xl" data-id="element-1180" data-mp="2l2wx9nf48ru7">
                  <h3 className="text-xl font-bold text-brand-gold mb-3" data-id="element-1181" data-mp="2l4zuosilln8y">
                    Custom Orders & Cancellations
                  </h3>
                  <p className="text-sm text-gray-300 mb-3" data-id="element-1182" data-mp="2v2dzfuv5snlf">
                    <strong data-id="element-1183" data-mp="2q29mufxdgd0h">Custom Orders:</strong> Address plaques,
                    personalized mailboxes, or engraved items are non-refundable
                    unless damaged/defective. America’s Finest and Bacova
                    mailboxes are made to order by hand and are non-returnable.
                  </p>
                  <p className="text-sm text-gray-300" data-id="element-1184" data-mp="3ds3wkome9lgi">
                    <strong data-id="element-1185" data-mp="3dtoqqd4sr2du">Cancellations:</strong> Many products ship within
                    24-48 hrs. To cancel, notify us immediately at{' '}
                    <a href="mailto:customerservice@midatlanticmailboxes.com" className="text-white hover:underline" data-id="element-1186" data-mp="3nr376cqpzr65">
                      customerservice@midatlanticmailboxes.com
                    </a>
                    . If shipped, you are responsible for return shipping and
                    restocking fees.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-1187" data-mp="9zorbkuzo8w6" />
      <MobileStickyBar data-id="element-1188" data-mp="9zymdmuw568q" />
    </div>;
}